import React, { useEffect, useState } from 'react';
import { Col, Row, Card, Form } from 'react-bootstrap';
import { search as searchSubSkill } from 'services/skill-matric-services/smSubSkillService';
import {
  search as searchCriteria
} from 'services/skill-matric-services/smSkillCriteriaService';
import PropTypes from 'prop-types';
import InputDatePicker from 'components/pages/customer-service/action-plans/create-action-plan/InputDatePicker';
import MatrixUserDropdown from 'components/dropdowns/SkillMatrix/MatrixUserDropdown';

export default function SubSkillCheckList({
  trainingId = 0,
  trainee,
  skillLevelId,
  areaId,
  outSubChecks
}) {
  const [criterias, setCriterias] = useState([]);
  const [checks, setChecks] = useState([]);
  // const [subSkills, setSubSkill] = useState([]);
  // const [subSkillChecks, setSubSkillChecks] = useState([]);

  useEffect(() => {
    console.log(skillLevelId);
    if (skillLevelId) {
      searchCriteria({ isGetAll: true, skillLevelId }).then(res => {
        setCriterias(res.items);
        console.log(res.items);
      });
    }
  }, [skillLevelId]);

  useEffect(() => {
    if (skillLevelId && areaId) {
      searchSubSkill({ isGetAll: true, areaId, skillLevelId, trainingId })
        .then(res => {
          // setSubSkill(res.items.sort((a, b) => a.position - b.position));

          // const mapped = mapSubSkillCheck(res.items, subSkillChecks);
          setChecks(res.items.sort((a, b) => a.position - b.position));
        })
        .catch(err => {
          console.log('Error in user fetch', err);
        });
    }
  }, [skillLevelId, areaId]);

  // const mapSubSkillCheck = (sSkills, sSkillChecks) => {
  //   console.log(sSkills, sSkillChecks)
  //   return sSkills.map(subSkill => {
  //     let rs = subSkill;
  //     if (sSkillChecks.length > 0) {
  //       const checkedSkill = subSkillChecks.find(
  //         i => subSkill.id === i.subSkillId
  //       );
  //       console.log(subSkill.id, checkedSkill);
  //       rs = {
  //         ...rs,
  //         trainerId: checkedSkill ? checkedSkill.trainerId : 0,
  //         trainingDate: checkedSkill ? checkedSkill.trainingDate : null
  //       };
  //     }
  //     return rs;
  //   });
  // };

  const cssBase = {
    display: 'flex',
    gap: '10px',
    justifyContent: 'left',
    alignItems: 'baseline',
    marginBottom: '10px'
  };

  return (
    <>
      {
        <Card className="mb-3">
          <Card.Body className="bg-light" style={{ minHeight: '840px' }}>
            {criterias?.filter(
              (c, idx, arr) => arr.findIndex(x => x.skillActivityId === c.skillActivityId) === idx
            ).map((c, idx) => (
              <Row className="gx-2 gy-4" key={idx}>
                <Col md={6}>
                  <Row rows={12}>
                    <Form.Group controlId="title">
                      <Form.Label>
                        <span>{c.skillActivityRef + ". " + c.skillActivityName}</span>
                      </Form.Label>
                    </Form.Group>
                  </Row>
                </Col>
                <Col md={6}>
                  <Row className="gx-2 gy-3">
                    <Col md={4}>
                      <Form.Group controlId="title" style={cssBase}>
                        <Form.Label>Trainee</Form.Label>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group controlId="title" style={cssBase}>
                        <Form.Label>Trainer</Form.Label>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group controlId="title" style={cssBase}>
                        <Form.Label>Date</Form.Label>
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>

                {checks.filter(x=>x.skillActivityId == c.skillActivityId )?.map((i, idx) => (
                  <Row key={idx}>
                    <Col md={6}>
                      <Row rows={12}>
                        <Form.Group controlId="title">
                          <Form.Label>
                            <span
                              style={{
                                display: 'inline-block',
                                minWidth: '25px',
                                textAlign: 'right',
                                paddingRight: '10px'
                              }}
                            >
                              {i.position}.{' '}
                            </span>
                            <span>{i.skillName}</span>
                          </Form.Label>
                        </Form.Group>
                      </Row>
                    </Col>
                    <Col md={6}>
                      <Row key={idx} className="gx-2 gy-3">
                        <Col md={4}>
                          <MatrixUserDropdown
                            disabled={true}
                            fieldName="trainee"
                            isMulti={false}
                            closeMenuOnSelect
                            handleChange={(key, value) => {
                              console.log('subSkillId: ' + i.id);
                              console.log(key, value);
                            }}
                            placeholder="Trainee"
                            value={trainee}
                          />
                        </Col>
                        <Col md={4}>
                          <MatrixUserDropdown
                            disabled={false}
                            fieldName="trainer"
                            isMulti={false}
                            closeMenuOnSelect
                            handleChange={(key, value) => {
                              let newChecks = checks.map(x => {
                                return i.id == x.id
                                  ? {
                                      ...x,
                                      trainerId: value.userId
                                    }
                                  : x;
                              });

                              setChecks(newChecks);
                              outSubChecks(newChecks);
                            }}
                            placeholder="Trainer"
                            value={i.trainerId}
                          />
                        </Col>
                        <Col md={4}>
                          <Form.Group controlId="title" style={cssBase}>
                            <InputDatePicker
                              column="trainingDate"
                              handleChange={(key, value) => {
                                let newChecks = checks.map(x => {
                                  return i.id == x.id
                                    ? {
                                        ...x,
                                        trainingDate: value == '' ? null : value
                                      }
                                    : x;
                                });

                                setChecks(newChecks);
                                outSubChecks(newChecks);
                              }}
                              selected={
                                i.trainingDate ? new Date(i.trainingDate) : null
                              }
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                ))}
              </Row>
            ))}
          </Card.Body>
        </Card>
      }
    </>
  );
}

SubSkillCheckList.propTypes = {
  handleFilterChange: PropTypes.func,
  trainingId: PropTypes.number,
  trainee: PropTypes.number,
  skillLevelId: PropTypes.number,
  skillActivityId: PropTypes.number,
  areaId: PropTypes.number,
  outSubChecks: PropTypes.number
};
